import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  handoutsTitle: {
    id: 'course-authoring.course-updates.handouts.title',
    defaultMessage: 'Course handouts',
  },
  editButton: {
    id: 'course-authoring.course-updates.actions.edit',
    defaultMessage: 'Edit',
  },
});

export default messages;
